module.exports={
  "test": true,
  "races": [
    {
      "id": "49391",
      "date": "3/10/2020",
      "state": "WA",
      "party": "Dem",
      "office": "P",
      "results": [
        {
          "id": "49391",
          "party": "Dem",
          "updated": 1584123058552,
          "precincts": 0,
          "reporting": 0,
          "reportingPercentage": 0,
          "winners": [],
          "total": 0,
          "candidates": [
            {
              "first": "Amy",
              "last": "Klobuchar",
              "party": "Dem",
              "id": "51526",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Tulsi",
              "last": "Gabbard",
              "party": "Dem",
              "id": "62589",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Bernie",
              "last": "Sanders",
              "party": "Dem",
              "id": "1445",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Joe",
              "last": "Biden",
              "party": "Dem",
              "id": "1036",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Cory",
              "last": "Booker",
              "party": "Dem",
              "id": "63133",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Pete",
              "last": "Buttigieg",
              "party": "Dem",
              "id": "67933",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Tom",
              "last": "Steyer",
              "party": "Dem",
              "id": "67935",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Andrew",
              "last": "Yang",
              "party": "Dem",
              "id": "67936",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Elizabeth",
              "last": "Warren",
              "party": "Dem",
              "id": "62244",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Michael",
              "last": "Bloomberg",
              "party": "Dem",
              "id": "32324",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Deval",
              "last": "Patrick",
              "party": "Dem",
              "id": "51516",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "John",
              "last": "Delaney",
              "party": "Dem",
              "id": "61562",
              "votes": 0,
              "percentage": 0
            },
            {
              "first": "Michael",
              "last": "Bennet",
              "party": "Dem",
              "id": "59911",
              "votes": 0,
              "percentage": 0
            },
            {
              "last": "Uncommitted",
              "party": "Dem",
              "id": "100004",
              "votes": 0,
              "percentage": 0
            }
          ]
        }
      ]
    }
  ]
}